module.exports = __webpack_public_path__ + "img/sender-id.0d53ef19.png";